import { BellIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Alert = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <BellIcon color={fill} size={Sizes[size]} {...rest} />;
};

Alert.displayName = 'Alert';
